/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "meloappAPI",
            "endpoint": "https://q7f622c1s0.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:a4d03a80-21c0-4288-854d-1c9ff2e0d41b",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_KsIAHajUS",
    "aws_user_pools_web_client_id": "8p0gj2jupbeif1cskkcfq1k4o",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "meloappDB-prod",
            "region": "us-east-2"
        }
    ],
    "aws_user_files_s3_bucket": "meloapps3bucket183305-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
